<template>
  <div>
    <!--  <b-alert show variant="danger" v-if="!appConnections">
      <a style="color: blue" href="https://dev.admin.gozwing.com/sh/eRgXta">Download</a> Application.
      <span class="float-right">
        <button
          type="button"
          class="btn btn-danger btn-sm"
          style="padding: 5px; margin-top: -6px;"
          @click="checkApplication"
          :disabled="printerLoading"
        >
          <span v-if="printerLoading == false">Check Connection</span>
          <b-spinner small v-if="printerLoading == true"></b-spinner>
        </button>
        <div class="clearfix"></div>
      </span>
    </b-alert>-->

    <div v-if="!appConnections" class="prnt">
      <p>
        Before you begin, please ensure that the printer's drivers and other
        necessary software is installed on your system. You may download them
        from the manufacturer’s website and install them before installing ZWING
        Utility.
        <br />
        <br />Once all drivers have been installed, download &amp; install the
        ZWING Utility by selecting your operating system below:
      </p>
      <p class="mt-5 mb-5">
        <b-row>
          <b-col lg="3" md="4" class="text-center">
            <a
              href="https://dev.admin.gozwing.com/sh/eRgXta"
              target="_blank"
              class="btn-theme btn-lg d-block mb-1 pt-3 pb-3 align-items-center"
              :class="state.system.isOffline ? 'disable' : null"
              id="download-qz"
            >
              <span class="float-left mt-2 ml-2">
                <img src="@/assets/images/windows.svg" alt />
              </span>
              <span>Download for</span>
              <br />
              <span class="os">Windows</span>
            </a>

            <!-- <span class="float-left mt-2 ml-2">
                <img src="@/assets/images/windows.svg" alt />
              </span> 
              <span>Download for</span>
              <br />
              <span class="os">Windows</span>
            </a>-->
            <span class="text-primary"> for Windows 7 and above</span>
          </b-col>
          <b-col lg="3" md="4" class="text-center">
            <a
              class="btn-danger btn-lg d-block mb-1 pt-3 pb-3 align-items-center"
              @click="checkApplication"
              :disabled="printerLoading"
              id="check-connection"
            >
              <span class="float-left mt-2 ml-2">
                <span v-if="!printerLoading">
                  <font-awesome-icon icon="print" size="lg" />
                </span>
                <b-spinner small v-if="printerLoading" />
              </span>
              <div>
                <span class="printer-set">Check printer</span>
                <br />
                <span class="os">Connection</span>
              </div>
            </a>
          </b-col>
        </b-row>
      </p>
      <p>
        ZWING Utility currently available for Windows only. MacOS &amp; Linux
        versions coming soon.
      </p>
    </div>
    <div v-if="appConnections" id="printers">
      <h5 class="fw-normal">Available Printers</h5>
      <b-card no-body>
        <b-tabs pills card vertical nav-wrapper-class="w-50">
          <b-tab v-for="list in printerList" :title="list" :key="list">
            <template v-slot:title>
              <span v-if="state.system.printer == list">
                <span v-text="state.system.printer" />
                <b-badge class="float-right" variant="success"
                  >Default Printer</b-badge
                >
              </span>
            </template>
            <b-card-text>
              <!-- <div> -->
              <div class="text-center">
                <div v-if="state.system.printer != ''">
                  <h6 class="pt-0">Default Printer</h6>
                  <p v-text="state.system.printer"></p>
                </div>
                <div class="col-md-12 p-3" style="margin-top: 20px !important;">
                  <div>
                    <b-button
                      v-if="state.system.printer == list"
                      variant="primary"
                      class="mr-1 mb-2"
                      @click="testPrint"
                      id="test-print"
                    >
                      Test Print
                    </b-button>
                    <b-button
                      v-if="state.system.printer == list"
                      variant="danger"
                      class="mb-2"
                      @click="removeDefault"
                      id="remove-default"
                    >
                      Remove Default
                    </b-button>

                    <b-button
                      v-else
                      variant="primary"
                      @click="setDefaultPrinter(list)"
                      id="set-printer"
                      class="mb-2"
                    >
                      Set Default Printer
                    </b-button>
                  </div>
                </div>
              </div>
              <!-- </div> -->
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
    <!--   <b-card no-body header="Available Printers" v-if="appConnections">
      <b-list-group flush>
        <b-list-group-item
          v-for="list in printerList"
          href="#"
          :key="list"
          @click="setDefaultPrinter(list)"
        >
          {{ list }}
          <button
            v-if="state.printer == list"
            type="button"
            class="btn btn-success float-right"
            style="padding: 3px 10px;"
          >Default Printer</button>
        </b-list-group-item>
      </b-list-group>
    </b-card>-->

    <!-- Default Printer Modal Box -->

    <b-modal
      id="default-printer-modal"
      size="sm"
      hide-footer
      hide-header
      centered
    >
      <p class="fs-14 d-flex title">
        <img src="../assets/images/icon_notif.svg" alt class="mr-2" /> Set
        default printer
      </p>
      <h5 class="pt-2 mb-0" v-text="defaultPrinter" />
      <div class="d-flex mt-4">
        <b-button
          class="mr-1"
          variant="outline-primary"
          id="cancel-printerr"
          @click="$bvModal.hide('default-printer-modal')"
          >Cancel</b-button
        >
        <b-button
          class="ml-1"
          variant="primary"
          @click="saveDefaultPrinter"
          :disabled="$loading"
          id="set-printerr"
        >
          Set
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import qz from "../printer";
import * as msg from "../message";
// import sift from "qz-sift";
// import axios from "axios";

export default {
  name: "printer",
  data() {
    return {
      appConnections: false,
      printerLoading: false,
      printerList: [],
      printerOption: [],
      defaultPrinter: "",
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    billLogo() {
      return this.$store.getters["system/billLogo"];
    },
  },
  mounted() {
    let self = this;
    setTimeout(function() {
      self.checkApplication();
    }, 300);
  },
  methods: {
    checkApplication() {
      console.log("Start Function");
      let self = this;
      this.printerLoading = true;
      // console.log(this.printerLoading);
      if (!qz.websocket.isActive()) {
        self.printerLoading = false;
      } else {
        self.appConnections = true;
        self.printerLoading = false;
        self.getPrinterList();
      }
    },
    getPrinterList() {
      if (this.appConnections) {
        qz.printers.find().then((item) => {
          // console.log(item);
          item.map((print) => {
            this.printerList.push(print);
          });
          // console.log(qz);
        });
        qz.printers.details().then((data) => {
          // console.log(data);
        });
        // console.log(qz.printers.getStatus());
        // qz.usb.claimDevice();
        // console.log(qz.configs.setDefaults);
        // qz.configs.setDefaults.map(options => {
        //   console.log(qz.configs.setDefaults);
        // });
      } else {
        this.printerList.push("No Printer Available");
        let alertData = {
          message: msg.PRINT_NOT_WORKING,
          type: "danger",
        };
        this.$showAlert = true;
        this.$store.commit("notifications/showAlert", alertData);
      }
    },
    setDefaultPrinter(value) {
      this.defaultPrinter = value;
      this.$bvModal.show("default-printer-modal");
    },
    saveDefaultPrinter() {
      this.$store.commit("system/setDefaultPrinter", this.defaultPrinter);
      this.$bvModal.hide("default-printer-modal");
    },
    removeDefault() {
      this.defaultPrinter = "";
      this.$store.commit("system/setDefaultPrinter", "");
      this.$store.commit("notifications/showAlert", {
        message: msg.REMOVE_DEFAULT_PRINTER,
        type: "success",
      });
      this.$showAlert = true;
    },
    testPrint() {
      let config = qz.configs.create(this.state.system.printer, {
        units: "mm",
      });

      var data = [
        "\x1B" + "\x40", // init
        this.billLogo.data[0].data != "" ? "\x0A" : "",
        "\x1B" + "\x61" + "\x31", // center align
        "\x1B" + "\x45" + "\x0D", //Bold On
        "Zwing" + "\x0A",
        "\x1B" + "\x45" + "\x0A", // bold off
        "------------------------------------------" + "\x0A",
        "Test Print" + "\x0A",
        "------------------------------------------" + "\x0A",
        "\x1B" + "\x61" + "\x30", // left align
        "ABCDEFGHIJKLMNOPQRSTUVWXYZ ABCDEFGHIJKLMNOPQRSTUVWXYZ" + "\x0A",
        "abcdefghijklmnopqrstuvwxyz abcdefghijklmnopqrstuvwxyz" + "\x0A",
        "------------------------------------------" + "\x0A",
        "\x1B" + "\x61" + "\x31", // center align
        "Buy me a coffee!" + "\x0A",
        "suppport@zwing.in " + "\x0A",
        "------------------------------------------" + "\x0A",
        "\x0A",
        "Selected Printer: " + this.state.system.printer + "\x0A",
        "\x0A" + "\x0A",
        // "\x1B" + "\x69", // cut paper (old syntax)
      ];

      var qconfig = qz.configs.create(this.state.system.printer, {
        encoding: "ISO-8859-1",
      });
      var qr = "https://zwing.in/";
      var dots = "\x08";
      var qrLength = qr.length + 3;
      ``;
      var size1 = String.fromCharCode(qrLength % 256);
      var size0 = String.fromCharCode(Math.floor(qrLength / 256));

      var qdata = [
        "\x1D" +
          "\x28" +
          "\x6B" +
          "\x04" +
          "\x00" +
          "\x31" +
          "\x41" +
          "\x32" +
          "\x00",
        "\x1D" + "\x28" + "\x6B" + "\x03" + "\x00" + "\x31" + "\x43" + dots,
        "\x1D" + "\x28" + "\x6B" + "\x03" + "\x00" + "\x31" + "\x45" + "\x30",
        "\x1D" +
          "\x28" +
          "\x6B" +
          size1 +
          size0 +
          "\x31" +
          "\x50" +
          "\x30" +
          qr,
        "\x1D" + "\x28" + "\x6B" + "\x03" + "\x00" + "\x31" + "\x51" + "\x30",
        "\x1D" + "\x28" + "\x6B" + "\x03" + "\x00" + "\x31" + "\x52" + "\x30",
        "\x0A" + "\x0A" + "\x0A" + "\x0A" + "\x0A",
        "\x1B" + "\x69", // cut paper
      ];

      if (this.billLogo.data[0].data == "")
        qz.print(config, data).then(() => qz.print(qconfig, qdata));
      else
        qz.print(this.billLogo.config, this.billLogo.data).then(() =>
          qz.print(config, data).then(() => qz.print(qconfig, qdata))
        );
    },
  },
};
</script>

<style lang="scss" scoped>
.theme-color {
  color: $theme-color;
}
.theme-dark {
  .prnt {
    .theme-color {
      color: #336666;
    }
  }
}
.btn-lg:hover {
  opacity: 0.8;
}
.btn-lg {
  font-weight: 300;
  font-size: 14px;
  line-height: 20px;
  color: $white-color !important;
  .os {
    font-size: 20px;
  }
}
// .theme-light .card a {
//   /*color: #fff;*/
// }
.badge {
  text-overflow: inherit !important;
}
#default-printer-modal header button {
  line-height: 0px;
}
.theme-dark #default-printer-modal ul {
  li p {
    color: #fff;
  }
}
#default-printer-modal ul {
  text-align: center;
  padding: 0px;
  li {
    list-style-type: none;
    padding-bottom: 10px;
    p {
      color: #404040;
    }
  }
  li + li {
    padding-bottom: 0px;
  }
}

#default-printer-modal button {
  padding: 0.475rem 1rem;
  width: 120px;
}
// #default-printer-modal .btn-danger {
//   background: #cc3333 !important;
//   border: 1px #cc3333 solid !important;
// }
.theme-dark #default-printer-modal .grey-outline-btn {
  border: 1px #606060 solid;
  background-color: transparent !important;
  color: #606060;
  width: 120px;
}
#default-printer-modal .grey-outline-btn {
  border: 1px #808080 solid;
  background-color: transparent !important;
  color: #808080;
  width: 120px;
}
#default-printer-modal .grey-outline-btn:focus:active {
  border: 1px #808080 solid;
  background-color: #808080 !important;
  color: #fff;
}
#default-printer-modal .grey-outline-btn:hover {
  border: 1px #808080 solid;
  background-color: #808080 !important;
  color: #fff;
}
.btn-grey:disabled:hover {
  opacity: 0.3 !important;
}
.disable {
  pointer-events: none;
}
.theme-dark .list-group-item {
  background: #404040;
}
.theme-dark .list-group-item:hover {
  background: #202020;
}
.theme-dark .modal h5 {
  color: #c0c0c0;
}
.modal h5 {
  font-weight: 400;
  font-size: 0.875rem;
}
.theme-dark h5 {
  color: #fff;
}
.theme-dark .prnt p {
  font-size: 14px !important;
  font-weight: 400;
  color: #808080;
}

.prnt p {
  // font-size: 1rem;
  font-weight: 400;
  color: #606060;
}
.printer-set {
  margin-left: -18px;
}
.theme-light .setting .left-side #printers .tab-content .card-body {
  background-color: #ffffff;
  p {
    font-size: 1.25rem;
  }
}
.badge-success {
  font-weight: normal;
  padding: 5px;
}
@media only screen and (max-width: 1025px) {
  .printer-set {
    margin-left: -5px;
  }
}
</style>
